import { createSelector } from 'reselect';
import { get } from 'lodash-es';
import { getVideoDisplaySettingsSelector } from 'common/selectors';

export const videoBoxSelector = createSelector(
  (state) => state.videoBox,
  (videoBox) => videoBox
);

export const getVideoSelector = createSelector(videoBoxSelector, (videoBox) => videoBox && videoBox.video);

export const getVideoUploaderSelector = createSelector(videoBoxSelector, (videoBox) =>
  videoBox ? videoBox.videoUploader : null
);

export const getVideoResponsibleUserSelector = createSelector(
  videoBoxSelector,
  getVideoUploaderSelector,
  getVideoDisplaySettingsSelector,
  (videoBox, videoUploader, displaySettings) => {
    const videoResponsibleUser = get(videoBox, 'videoResponsibleUser');
    const showUploader = get(displaySettings, 'uploader');

    if (videoResponsibleUser) {
      return videoResponsibleUser;
    } else if (showUploader) {
      return videoUploader;
    } else {
      return null;
    }
  }
);

export const getVideoIdSelector = createSelector(getVideoSelector, (video) => get(video, 'id'));

export const getUITVideoisDownloadableSelector = createSelector(getVideoSelector, (video) => {
  const status = get(video, 'uitVideoDownloadableStatus', 0);
  return status === 1 || status === 2;
});

export const getCountVideoCommentSelector = createSelector(
  getVideoSelector,
  (state) => state.videoComments,
  (video, videoComments) =>
    videoComments && videoComments.total !== null ? videoComments.total : video && video.totalComments
);

export const getVideoBoxUISelector = createSelector(videoBoxSelector, ({ loading, error }) => ({ loading, error }));
